import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=08a2c12a&"
import script from "./tabs.vue?vue&type=script&lang=js&"
export * from "./tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Devdoc\\_packages\\moss-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08a2c12a')) {
      api.createRecord('08a2c12a', component.options)
    } else {
      api.reload('08a2c12a', component.options)
    }
    module.hot.accept("./tabs.vue?vue&type=template&id=08a2c12a&", function () {
      api.rerender('08a2c12a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/tabs.vue"
export default component.exports